var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-breadcrumb",
    { staticClass: "dl-breadcrumb", attrs: { separator: "/" } },
    _vm._l(_vm.item, function (i, index) {
      return _c(
        "el-breadcrumb-item",
        { key: i[1] + index, attrs: { to: i[1] ? { name: i[1] } : "" } },
        [_vm._v(_vm._s(i[0]))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }